export class Group {
  id?: number;
  name?: string;
  priority?: number;
  isPaid?: boolean;
}

export class Source {
  id?: number;
  name?: string;
  priority?: number;
  groupId?: number;
  isSourceEdit?: boolean;
  rules?: Rule[] = [];
}

export class Rule {
  filter?: string;
  state?: string;
  text?: string;
  isExpr?: boolean = false;
  exprId?: number = 0;
  exprStart?: boolean = false;
  exprEnd?: boolean = false;
}

